import { Component, OnInit } from '@angular/core';
import { AuthManager } from './core/auth/auth.manager';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private isIframe = false;

  constructor(private readonly auth: AuthManager) {}

  public ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;
    this.auth.restoreOrCreateSession();
  }

  public loginRedirect(): void {
    this.auth.loginRedirect();
  }
}
